/**
 * Simple token manager - relies on backend filter for token refresh.
 * The backend reads X-Refresh-Token header and returns new tokens
 * in response headers (X-New-Access-Token, X-New-Refresh-Token, X-Token-Expires-In).
 */

export const getAccessToken = (): string | null => {
  return sessionStorage.getItem('access_token');
};

export const getRefreshToken = (): string | null => {
  return sessionStorage.getItem('refresh_token');
};

export const setTokens = (accessToken: string, refreshToken?: string): void => {
  sessionStorage.setItem('access_token', accessToken);
  if (refreshToken) {
    sessionStorage.setItem('refresh_token', refreshToken);
  }
};

export const clearTokens = (): void => {
  sessionStorage.removeItem('access_token');
  sessionStorage.removeItem('refresh_token');
};

// Keep backward compatibility
export const getValidToken = async (): Promise<string | null> => {
  return getAccessToken();
};

export const initTokenManager = (): void => {
};

export const clearTokenManager = (): void => {
  clearTokens();
};
